import { BonusXLogo } from "../../../../components/blocks/BonusXLogo";
import { EmptyComponent } from "../../common/EmptyComponent";
import type { IHeaderV2LayoutStore } from "../stores/header-v2-layout-store";

type HeaderV2LogoProps = Pick<IHeaderV2LayoutStore, "showLogo" | "forceLogoExtended"> & {
  isLogoClickable?: boolean;
};

function HeaderV2Logo({
  showLogo,
  forceLogoExtended,
  isLogoClickable = true,
}: Readonly<HeaderV2LogoProps>): JSX.Element {
  if (!showLogo) {
    return <EmptyComponent />;
  }

  return <BonusXLogo forceLogoExtended={forceLogoExtended} isClickable={isLogoClickable} />;
}

export default HeaderV2Logo;
